import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M20.3249 22.475L1.5249 3.67498L2.5999 2.59998L21.3999 21.4L20.3249 22.475ZM2.9999 7.49998V5.99998H5.3499V7.49998H2.9999ZM5.9999 12.75V11.25H10.5999V12.75H5.9999ZM9.6249 7.49998L8.1249 5.99998H20.9999V7.49998H9.6249ZM9.9999 18V16.5H13.9999V18H9.9999ZM14.8749 12.75L13.3749 11.25H17.9999V12.75H14.8749Z" />,
  'FilterListOff',
)
